import { LegalDocumentType } from "./enums/LegalDocumentType";
import { ApiClient } from "./clients";
import { Collection } from "./models/common/Collection";
import { LegalDocument } from "./models/documents/LegalDocument";

export class LegalDocumentProvider {
  constructor(private readonly apiClient: ApiClient) {}

  getList(type: LegalDocumentType): Promise<Collection<LegalDocument>> {
    return this.apiClient.get(`?type=${type}`);
  }
}
